import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ServicioPerfilDeAutoridadService {
  
  autoridadAislante=false
  autoridadHSE=false;
  autoridadArea=false;
  gerenteCampo=false
  autoridadAreaLocal=false
  autoridadElectrica=false
  autoridadAmbiental=false
  auditor=false
  
  
  
  datosAutoridad;

  constructor() { }

}
